module.exports = __webpack_public_path__ + "static/img/about.f3c0e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/about/about.png
// module id = dVHn
// module chunks = 1